// V1 local-only client. No auth headers — the consumer app no longer has
// a user identity. Device-keyed endpoints (/api/devices/*) take a UUID
// in the body; everything else is anonymous.

const API_URL = import.meta.env.VITE_API_URL || 'https://moonpath-kids-api.winter-lake-b4eb.workers.dev'

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...options.headers }
  const res = await fetch(`${API_URL}${path}`, { ...options, headers })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }))
    throw new Error(err.error || 'Request failed')
  }
  return res.json()
}

export const api = {
  // ── Public content ──
  getFeed: () => request('/api/feed'),
  getStories: () => request('/api/stories'),
  getStory: (id) => request(`/api/stories/${id}`),
  getChoiceStats: (storyId, nodeId) => request(`/api/stats/${storyId}/${nodeId}`),
  recordChoice: (storyId, nodeId, choiceIndex) =>
    request('/api/stats', { method: 'POST', body: JSON.stringify({ storyId, nodeId, choiceIndex }) }),

  // Anonymous "+stars" event from an ending screen. No identifiers
  // travel with the rating — just storyId + stars 1-5.
  submitRating: (storyId, stars) =>
    request('/api/ratings', { method: 'POST', body: JSON.stringify({ storyId, stars }) }),

  // ── Devices (V1 local-only) ──
  registerDevice: (body) =>
    request('/api/devices/register', { method: 'POST', body: JSON.stringify(body) }),
  pingDevice: (body) =>
    request('/api/devices/ping', { method: 'POST', body: JSON.stringify(body) }),

  // Anonymous story-engagement events: 'start' fires once when the
  // player mounts a story, 'ending' fires when the kid hits an
  // ending node (carries ending_id). Powers the admin Story Health
  // table. Fire-and-forget — caller wraps in .catch so a flaky
  // network never affects playback.
  recordEvent: ({ deviceId, eventType, storyId, endingId }) =>
    request('/api/events', {
      method: 'POST',
      body: JSON.stringify({
        device_id: deviceId,
        event_type: eventType,
        story_id: storyId,
        ending_id: endingId || null,
      }),
    }),
}
